"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function AboutUs() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section id="about-us" className="!bg-[hsl(33,21%,81%)] ![padding:96px_32px_96px_32px]">
      <div className="mx-auto max-w-7xl">
        <div className="grid grid-cols-1 gap-8 items-start pt-10 md:grid-cols-2 md:gap-12 lg:gap-16">
          
          {/* Left Column: Animated Content */}
          <div ref={leftRef} className="transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)]" style={{
          opacity: leftVisible ? 1 : 0,
          transform: leftVisible ? "translateX(0)" : "translateX(-20px)"
        }}>
            <h2 className="font-display font-bold text-foreground text-5xl ![margin:50px_0px_30px_0px]">
              About Us
            </h2>
            
            <p className="font-sans text-base text-foreground leading-relaxed md:text-lg mb-8">
              At KS LUXURY RENOVATIONS, we specialise in high-end residential and 
              commercial renovations in Cyprus, delivering refined spaces defined by 
              quality, balance, and timeless design. From concept to completion, we 
              manage every detail with care, creating environments that reflect your 
              lifestyle, your business, and your standards. Based in Limassol. 
              Trusted across Cyprus.
            </p>

            {/* Buttons are now inside the animated div */}
            <div className="flex flex-col sm:flex-row items-start justify-start gap-4">
              <Link to="/Contact">
                <Button className="px-4 py-2 text-sm inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md font-medium transition-all [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive bg-primary text-primary-foreground shadow-xs h-9 has-[>svg]:px-3 btn-primary !text-lg ![padding:24px_40px_24px_24px] disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:bg-primary/90">
                  Request a Private Consultation
                </Button>
              </Link>
              <Link to="/projects">
                <Button variant="outline" className="px-4 py-2 text-sm inline-flex items-center justify-center gap-2 whitespace-nowrap transition-all [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive shadow-xs h-9 has-[>svg]:px-3 rounded-full bg-background text-foreground font-semibold border border-border !text-lg !p-6 disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:text-accent-foreground dark:bg-input/30 dark:border-input dark:hover:bg-input/50 hover:bg-muted-light-background hover:shadow-medium hover:-translate-y-0.5 active:translate-y-0">
                  View Our Projects
                </Button>
              </Link> 
            </div>
          </div>

          {/* Right Column: Image */}
          <div ref={rightRef} className="transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] group" style={{
          opacity: rightVisible ? 1 : 0,
          transform: rightVisible ? "translateX(0)" : "translateX(20px)"
        }}>
            <div className="relative overflow-hidden rounded-xl shadow-soft hover:shadow-medium transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)]">
              <img src="https://ksluxury.cloudtech.com.cy/wp-content/uploads/2026/02/male-worker-using-wood-cutting-circular-saw-machine-workshop_1920.jpg" alt="Modern architectural building showcasing Lumoria design" className="w-full h-auto object-cover transition-transform duration-[var(--duration-medium)] ease-[var(--ease-out-back)] group-hover:scale-[1.02]" />
              <div className="absolute inset-0 bg-secondary/0 group-hover:bg-secondary/5 transition-colors duration-[var(--duration-medium)] ease-[var(--ease-smooth)]" />
            </div>
          </div>

        </div>
      </div>
    </section>;
}